import { Routes } from "@angular/router";

import { AuthGuard, PermissionsGuard } from "@zonar-ui/auth";

import { WizardComponent } from "src/app/components/wizard/wizard.component";
import { AssetDetailsComponent } from "../../../views/asset-details/asset-details.component";
import { DefectListComponent } from "../../../views/defect-list/defect-list.component";
import { InspectionDetailComponent } from "../../../views/inspection-detail/inspection-detail.component";
import { InspectionHistoryComponent } from "../../../views/inspection-history/inspection-history.component";
import { InspectionsPrintViewComponent } from "../../inspections-print-view/inspections-print-view.component";
import { MirRulesComponent } from "../../mir-rules/mir-rules.component";
import { MissingInspectionsComponent } from "../../missing-inspections/missing-inspections.component";
import { NjmvcDriversVehicleInspectionReportComponent } from "../../njmvc-drivers-vehicle-inspection-report/njmvc-drivers-vehicle-inspection-report.component";
import { SettingsComponent } from "../../settings/settings.component";

export const DEFAULT_ROUTES: Routes = [
	{ path: "", redirectTo: "inspection-list", pathMatch: "full" },
	{ path: "inspection-list", component: InspectionHistoryComponent, canActivate: [AuthGuard, PermissionsGuard] },
	{
		path: "inspections-print-view",
		component: InspectionsPrintViewComponent,
		canActivate: [AuthGuard, PermissionsGuard],
	},
	{
		path: "njmvc-drivers-vehicle-inspection-report",
		component: NjmvcDriversVehicleInspectionReportComponent,
		canActivate: [AuthGuard, PermissionsGuard],
	},
	{ path: "settings", component: SettingsComponent, canActivate: [AuthGuard, PermissionsGuard] },
	{
		path: "company/:company-uuid/inspection/:inspection-uuid",
		component: InspectionDetailComponent,
		canActivate: [AuthGuard, PermissionsGuard],
	},
	{ path: "defects", component: DefectListComponent, canActivate: [AuthGuard, PermissionsGuard] },

	{ path: "mir-rules", component: MirRulesComponent, canActivate: [AuthGuard, PermissionsGuard] },

	{ path: "missing-inspections", component: MissingInspectionsComponent, canActivate: [AuthGuard, PermissionsGuard] },
	{ path: "missing-inspections-v1", component: MissingInspectionsComponent, canActivate: [AuthGuard, PermissionsGuard] },
	{
		path: "company/:company-uuid/asset-details/:asset-uuid",
		component: AssetDetailsComponent,
		canActivate: [AuthGuard, PermissionsGuard],
	},
	{ path: "wizard", component: WizardComponent, canActivate: [AuthGuard, PermissionsGuard] },
];
